/**
 * 算法详情页面视图类型映射表
 *
 * 根据后端返回的 introduce.template 字段，映射到对应的页面组件
 * 新增类型时，只需在此更新映射
 *
 * 后端 template 值        →  组件文件夹
 * ─────────────────────────────────────────
 * general_recognition_trial → recognition_general  (有交互)
 * general_recognition       → common_algorithm     (无交互)
 * audio_denoising           → audio_denoising
 * image_comparison          → face_comparison
 * image_understanding       → image_understanding
 * general_ocr               → ocr_general
 * text_image                → text_image
 * recognition_slide         → recognition_slide
 * general_video/general_recognition_video   → video_general
 * general_voice             → voice_wakeup
 * language_model            → language_model
 */

// 后端 template 值 → 组件的映射
export const templateComponentMap = {
  general_recognition_trial: () =>
    import('@/views/recognition_general/index.vue'),
  general_recognition: () => import('@/views/common_algorithm/index.vue'),
  audio_denoising: () => import('@/views/audio_denoising/index.vue'),
  image_comparison: () => import('@/views/face_comparison/index.vue'),
  image_understanding: () => import('@/views/image_understanding/index.vue'),
  general_ocr: () => import('@/views/ocr_general/index.vue'),
  text_image: () => import('@/views/text_image/index.vue'),
  recognition_slide: () => import('@/views/recognition_slide/index.vue'),
  general_video: () => import('@/views/video_general/index.vue'),
  general_recognition_video: () => import('@/views/video_general/index.vue'),
  general_voice: () => import('@/views/voice_wakeup/index.vue'),
  language_model: () => import('@/views/language_model/index.vue'),
}

/**
 * 根据后端 introduce.template 获取对应的组件
 * @param {string} template - 后端返回的 introduce.template 值
 * @returns {Promise<object>} 动态导入的组件
 */
export async function getViewComponent(template) {
  template = template?.trim()
  const componentLoader = templateComponentMap[template]
  if (!componentLoader) {
    console.warn(
      `Template not found: ${template}, falling back to 'general_recognition'`,
    )
    const mod = await templateComponentMap['general_recognition']()
    return mod.default || mod
  }
  const mod = await componentLoader()
  return mod.default || mod
}

/**
 * 获取所有支持的 template 类型
 */
export function getSupportedTemplates() {
  return Object.keys(templateComponentMap)
}

/**
 * 检查是否支持某个 template 类型
 */
export function isSupportedTemplate(template) {
  return template in templateComponentMap
}
